
import { computed, defineComponent, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { overlayComposition } from '@/core/modules/overlay/services';

/**
 * Vue components define
 */
export default defineComponent({
	props: {
		datum: {
			type: Array,
			required: true,
		},
		view: {
			type: String,
			default: 'grid'
		}
	},	
	setup() {
		const router = useRouter();
		const route = useRoute();
		const store = useStore();

		// Computed router param
		const sectionId = computed((): string => route.params.sectionId as string || '');
		const visitedEndpoints = computed((): string[] => store.getters.get_visitedEndpoints || []);

		// Method to get SVG icon
		function requireSvgSource (type: string): string {
			try {
				return require(`!html-loader!../assets/images/${type}.svg`);
			} catch (err) {
				console.warn(err);
				return '';
			}
		}

		const { processOverlay } = overlayComposition();

		function processClick (endpoint: any) {
			if (endpoint && endpoint.endpointId) {
				store.dispatch('axn_updateVisitedEndpoints', endpoint.endpointId);
			}

			if (endpoint.reactive === 'true') {
				processOverlay(endpoint.endpointId);
			} else {
				navigateToEndpoint(endpoint);
			}
		}

		// Function to navigate to endpoint
		function navigateToEndpoint (endpoint: any): void {
			if (endpoint.type === 'pdf') {
				router.push(`/covid-hub/endpoint/${sectionId.value}/${endpoint.endpointId}?page=${endpoint.page}`);
			} else {
				router.push(`/covid-hub/endpoint/${sectionId.value}/${endpoint.endpointId}`);
			}
		}
		
		// Function to navigate to endpointId
		function navigateToEndpointId (endpointId: any): void {
			router.push(`/covid-hub/endpoint/${sectionId.value}/${endpointId}`);
		}

		/**
		 * Reactive functionality
		 */
		const reactiveActive = computed((): boolean => store.getters.get_reactiveState);

		// Function to check the reactive endpoint
		function checkEndpointReactive (isReactive: boolean): boolean {
			let displayEndpoint = true;

			if (isReactive) {
				displayEndpoint = reactiveActive.value;
			}

			return displayEndpoint;
		}

		// Store the state of the reactive slides - if hide or display them
		function updateReactiveDisplay (reactiveDisplay: boolean): void {
			store.dispatch('axn_updateReactiveState', reactiveDisplay);
		}

		watch(() => reactiveActive.value, () => {
			updateReactiveDisplay(reactiveActive.value)
		})

		return {
			visitedEndpoints, requireSvgSource, navigateToEndpoint, processClick, ...overlayComposition(),
			checkEndpointReactive, navigateToEndpointId
		}
	},
})
